import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import rocket from '../../../../assets/images/bg/rocket.png';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundImage: `url(${rocket})`,
      backgroundSize: '160px auto',
      backgroundPosition: 'right bottom 10px',
      backgroundRepeat: 'no-repeat',
      padding: '30px 40px',
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: 20,
      },
    },
    title: {
      fontWeight: 700,
      fontSize: 30,
      color: colorVariables.navy,
      marginBottom: 10,
    },
    subTitle: {
      fontWeight: 400,
      fontSize: 14,
      color: colorVariables.grey80
    },
    planContainer: {
      margin: '20px 0',
      '& strong': {
        fontWeight: 700
      }
    },
    greatBtn: {
      marginTop: 20,
    }
  }),
);
